import { useState } from "react"
import { useMutation, useQuery, UseQueryOptions, UseQueryResult } from "react-query"
import { APIEndpoints } from "../constants/api-endpoints"
import { HttpRequest } from "../services/_http"
import { QueryKeys } from "./_query_keys"

export const useAskQuestionData = (searchOptions?: any, options?: UseQueryOptions): UseQueryResult<any> => {
    const method = 'GET'
    const queryKey = [QueryKeys.ASK_QUESTION, searchOptions]
    
    const [keepPreviousData, setkeepPreviousData] = useState(true)
    
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: APIEndpoints.AskQuestion,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus: false,
        keepPreviousData,
        onError: () => setkeepPreviousData(false),
        onSuccess: () => setkeepPreviousData(true),
        ...options
    })
}

export const useAskQuestionByLevel = (level: string, options?: UseQueryOptions): UseQueryResult<any> => {
    const method = 'GET'
    const queryKey = [QueryKeys.ASK_QUESTION, 'level', level]
    
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.AskQuestion}/level/${level}`,
            method
        }),
        refetchOnWindowFocus: false,
        enabled: !!level,
        ...options
    })
}

export const useAskQuestionByParent = (parentId: number, options?: UseQueryOptions): UseQueryResult<any> => {
    const method = 'GET'
    const queryKey = [QueryKeys.ASK_QUESTION, 'parent', parentId]
    
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.AskQuestion}/parent/${parentId}`,
            method
        }),
        refetchOnWindowFocus: false,
        enabled: !!parentId,
        ...options
    })
}

export const useAskQuestionDetail = (questionId: any, options?: UseQueryOptions): UseQueryResult<any> => {
    const method = 'GET'
    const queryKey = [QueryKeys.ASK_QUESTION, questionId]
    
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.AskQuestion}/${questionId}`,
            method
        }),
        refetchOnWindowFocus: false,
        cacheTime: 0,
        enabled: !!questionId,
        ...options
    })
}

export const useCreateAskQuestion = (options?: any) => {
    const method = 'POST'
    return useMutation(({ data }: { data: any }) => HttpRequest({
        url: `${APIEndpoints.AskQuestion}`,
        method,
        data
    }), options)
}

export const useUpdateAskQuestion = (options?: any) => {
    const method = 'PUT'
    return useMutation(({ data, questionId }: { data: any, questionId: any }) => HttpRequest({
        url: `${APIEndpoints.AskQuestion}/${questionId}`,
        method,
        data
    }), options)
}

export const useUpdateAskQuestionStatus = (options?: any) => {
    const method = 'PATCH'
    return useMutation(({ status, questionId }: { status: string, questionId: any }) => HttpRequest({
        url: `${APIEndpoints.AskQuestion}/${questionId}/status`,
        method,
        data: { status }
    }), options)
}

export const useDeleteAskQuestion = (options?: any) => {
    const method = 'DELETE'
    return useMutation(({ questionId }: { questionId: any }) => HttpRequest({
        url: `${APIEndpoints.AskQuestion}/${questionId}`,
        method
    }), options)
}
